module.exports = __webpack_public_path__ + "static/img/indexImg.2ed1ebb9.png";